import { ROUTES } from 'base/routes/routes';
import { Route, Routes } from 'react-router-dom';

export const campaignRoutes = ({
  ContentManage,
  AddContent,
  EditContent,
  CampaignManage,
  AddCampaign,
  EditCampaign,
}: {
  // Quản lý nội dung
  ContentManage: React.ComponentType;
  // Tạo mới nội dung
  AddContent: React.ComponentType;
  // Chỉnh sửa nội dung
  EditContent: React.ComponentType;

  // Quản lý chiến dịch
  CampaignManage: React.ComponentType;
  // Thêm mới quản lý chiến dịch
  AddCampaign: React.ComponentType;
  // Chỉnh sửa quản lý chiến dịch
  EditCampaign: React.ComponentType;
}) => (
  <Routes>
    {/*========================== Quản lý nội dung =================================== */}
    <Route path={ROUTES.CAMPAIGN.CONTENT_MANAGE.BASE} element={<ContentManage />} />
    {/* Thêm mới nội dung */}
    <Route path={ROUTES.CAMPAIGN.CONTENT_MANAGE.CREATE.BASE} element={<AddContent />} />
    {/* Thêm mới nội dung */}
    <Route path={ROUTES.CAMPAIGN.CONTENT_MANAGE.DETAIL.BASE} element={<EditContent />} />

    {/*========================== Quản lý chiến dịch ==================================*/}
    <Route path={ROUTES.CAMPAIGN.CAMPAIGN_MANAGE.BASE} element={<CampaignManage />} />
    {/* Thêm mới quản lý chiến dịch  */}
    <Route path={ROUTES.CAMPAIGN.CAMPAIGN_MANAGE.CREATE.BASE} element={<AddCampaign />} />
    {/* Chỉnh sửa quản lý chiến dịch */}
    <Route path={ROUTES.CAMPAIGN.CAMPAIGN_MANAGE.DETAIL.BASE} element={<EditCampaign />} />
  </Routes>
);
